import { render, staticRenderFns } from "./locQuery_s1.vue?vue&type=template&id=f03bda72&scoped=true&"
import script from "./locQuery_s1.vue?vue&type=script&lang=js&"
export * from "./locQuery_s1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03bda72",
  null
  
)

export default component.exports